import { en } from './en'
import { language } from './language'
import { ru } from './ru'

const dictionary = (language === 'ru' ? ru : en).vocabulary

export type Vocabulary = typeof dictionary
export type VocabularyKind = keyof Vocabulary

export const term = (kind: VocabularyKind, value: string): string => {
  const table: Record<string, string> = dictionary[kind]
  return table[value] ?? value
}

export const terms = (kind: VocabularyKind): { value: string; label: string }[] =>
  Object.entries(dictionary[kind]).map(([value, label]) => ({ value, label }))

export const vocabulary = dictionary
